module.exports = __webpack_public_path__ + "static/media/editor.3dc959db.mp4";